import React from 'react';
import { LoginLayout } from '@cko/dashboard-shared';
import { PrimaryButton, Text } from '@cko/primitives';
import { useHistory } from 'react-router-dom';
import { VisualProvider } from '../../../../providers/VisualProvider';
import { ROUTES } from '../../Routes';

export const Expired = () => {
  document.title = 'Session expired';
  const history = useHistory();

  const handleSignInClick = () => {
    const query = new URLSearchParams(window.location.search);
    history.push(query.get('original_path') ?? ROUTES.home);
  };

  return (
    <VisualProvider>
      <LoginLayout title="Session expired">
        <Text mb="var(--layout-shoe)">To restore the page, please sign in again.</Text>
        <PrimaryButton onClick={handleSignInClick}>Sign in again</PrimaryButton>
      </LoginLayout>
    </VisualProvider>
  );
};
